<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">The courage we desire and prize</p>
<p class="ded1">is not the courage to die decently,</p>
<p class="ded1">but to live manfully.</p>
<p class="ded3">—T<span class="smallcaps">HOMAS</span> C<span class="smallcaps">ARLYLE</span></p>
<p class="ded2">God will not look you over for</p>
<p class="ded1">medals, degrees or diplomas, but</p>
<p class="ded1">for scars.</p>
<p class="ded3">—E<span class="smallcaps">LBERT</span> H<span class="smallcaps">UBBARD</span></p>
<p class="ded2">You say that a good cause will</p>
<p class="ded1">even sanctify war! I tell you,</p>
<p class="ded1">it is the good war that sanctifies every cause!</p>
<p class="ded3">—F<span class="smallcaps">RIEDRICH</span> N<span class="smallcaps">IETZSCHE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?14ea2cbe